import { getLocationSearch } from './getLocationSearch';
export default function getAppName() {
  const params = new URLSearchParams(getLocationSearch());
  return params.get('hostAppName');
}